import { useEffect, useState } from "react";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import BalanceSheetModel, { BalanceSheetSourceItem, BalanceSheetTechItem } from "../models/BalanceSheetModel";
import Div from "../../../../components/base/Div";
import Indicator from "../../../../components/base/Indicator";
import { setPage, setToolbarActions, toPrettyDate, useHub, useOwnerUserId, useScreen, useSocket } from "../../../../core/Global";
import Avatar from "../../../../components/base/Avatar";
import BalanceTechCard from "../components/BalanceTechCard";
import BalancePayedCard from "../components/BalancePayedCard";
import BalanceReceivedCard from "../components/BalanceReceivedCard";
import TextBox from "../../../../components/form/TextBox";
import BalanceTransaction, { BalanceTransactionParties, BalanceTransactionTypes } from "../models/BalanceTransaction ";
import TransactionForm from "../components/TransactionForm";
import { Link } from "react-router-dom";
import BalanceSourcesCard from "../components/BalanceSourcesCard";
import BalanceItemViewDrawer from "../components/BalanceItemViewDrawer";


export default function BalanceSheetView() {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    const hub = useHub()
    const screen = useScreen()
    const socket = useSocket()
    const ownerUserId = useOwnerUserId()

    const [loading, loadingSet] = useState<boolean>(true)
    const [loaded, loadedSet] = useState<boolean>(false)
    const [model, modelSet] = useState<BalanceSheetModel>()

    const [boxHeight, boxHeightSet] = useState<number>()

    const fixSizes = () => {

        var w = screen.width;
        var h = screen.height;

        h = h - ($("#kt_header").outerHeight() ?? 50);
        h = h - ($("#kt_toolbar").outerHeight() ?? 0);

        h = h - ($("#row-balance-digits").outerHeight() ?? 50);
        h = h - 130;

        boxHeightSet(h);
    }

    useEffect(() => {

        if (!loaded) return;

        fixSizes();
        window.addEventListener("resize", fixSizes);

        return () => {
            window.removeEventListener("resize", fixSizes);
        }

    }, [loaded])


    const ActionButtons = () => {
        return (
            <FlexRow>
                <button type="button" className="btn btn-sm btn-primary ms-auto"
                    onClick={e => createTransactionSet(true)}>
                    <Icon icon="plus" />
                    New Transaction
                </button>
            </FlexRow>
        )
    }

    useEffect(() => {
        setPage("Balance", "CRM")
        setToolbarActions(ActionButtons)


        return () => {
            setPage("")
            setToolbarActions(undefined)
        }
    }, [])

    useEffect(() => {
        hub.Post("/reports/balance/generate", {}, res => {
            if (res.success && res.data) {
                modelSet(res.data)
                loadingSet(false)
                loadedSet(true)
            }
        })
    }, [])


    useEffect(() => {

        var socketKey = socket.start(
            skt => {
                skt.invoke("StartListenToBalanceSheet", ownerUserId)
                    .then(() => {
                        skt.on("UpdateBalanceSheet", data => {
                            modelSet(data)
                        })
                    })

            }, skt => {
                skt.off("UpdateBalanceSheet")
                skt.invoke("StopListenToBalanceSheet", ownerUserId)
            })

        return () => {
            socket.stop(socketKey);
        }

    }, [])

    const [SelectedParty, SelectedPartySet] = useState<string>("1")
    const [createTransaction, createTransactionSet] = useState<boolean>(false)
    const [editTransaction, editTransactionSet] = useState<boolean>(false)
    const [selectedTransaction, selectedTransactionSet] = useState<BalanceTransaction>()

    const [searchKeyword, searchKeywordSet] = useState<string>("")

    const [selectedTech, selectedTechSet] = useState<BalanceSheetTechItem>()
    const [selectedSource, selectedSourceSet] = useState<BalanceSheetSourceItem>()

    return (
        <div className="p-5">

                <Div className="mt-20" visible={loading}>
                    <Indicator />
                </Div>

                <Div visible={loaded}>
                    <div id="row-balance-digits" className="row mb-5">

                        <div className="col-12 col-md-6 col-lg-3">
                            <BalanceTechCard balance={model?.techsBalance ?? 0} />
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <BalanceSourcesCard balance={model?.sourcesBalance ?? 0} />
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <BalancePayedCard amount={Math.abs(model?.totalPayed ?? 0)} />
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <BalanceReceivedCard amount={model?.totalRecieved ?? 0} />
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-12 col-lg-6">

                            <div className="card">
                                <div className="card-body py-0">

                                    <FlexRow className="mt-5 mb-5">
                                        <div className="flex-grow-1 me-10">
                                            <TextBox id="txt-search-techs-sources-balance"
                                                key={"txt-search-techs-sources-balance"}
                                                value={searchKeyword} onTextChanges={text => searchKeywordSet(text)}
                                                block labelUp icon="search" iconStart noMarginBottom
                                                placeholder="Search..." />
                                        </div>
                                        <div>

                                            <ul className="nav nav-pills nav-pills-custom">

                                                <li className="nav-item me-2">
                                                    <a data-bs-toggle="pill" href="#tab_techs_balance"
                                                        className="nav-link btn btn-outline btn-flex btn-active-color-primary flex-column overflow-hidden w-50px active"
                                                        onClick={e => {
                                                            SelectedPartySet("1")
                                                            searchKeywordSet("")
                                                        }}>
                                                        <FlexRow className="nav-icon mb-2">
                                                            <Icon icon="user-helmet-safety" size={20} />
                                                        </FlexRow>
                                                        <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                                    </a>
                                                </li>
                                                <li className="nav-item me-2">
                                                    <a data-bs-toggle="pill" href="#tab_sources_balance"
                                                        className="nav-link btn btn-outline btn-flex btn-active-color-primary flex-column overflow-hidden w-50px"
                                                        onClick={e => {
                                                            SelectedPartySet("2")
                                                            searchKeywordSet("")
                                                        }}>
                                                        <FlexRow className="nav-icon mb-2">
                                                            <Icon icon="bullhorn" size={20} />
                                                        </FlexRow>
                                                        <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                                                    </a>
                                                </li>

                                            </ul>

                                        </div>
                                    </FlexRow>



                                    <div className="tab-content">

                                        <div className="tab-pane fade active show" id="tab_techs_balance">
                                            <div className="table-responsive scroll-y" style={{
                                                height: boxHeight
                                            }}>
                                                <table className="table table-hover table-row-dashed align-middle gs-0 gy-4 my-0">
                                                    <tbody>
                                                        {
                                                            model?.techs?.filter(f => {
                                                                if (searchKeyword == "") return true;
                                                                return f.tech.fullName?.toLowerCase().includes(searchKeyword.toLowerCase())
                                                            }).map(t =>
                                                                <tr>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <Avatar avatarUrl={t.tech.avatarUrl} type="square"
                                                                                fullName={t.tech.fullName} textSize={20}
                                                                                width={30} className="me-3" />
                                                                            <div className="d-flex justify-content-start flex-column">
                                                                                <div className="text-gray-900 fw-bold text-hover-primaryfs-6 limited-text"
                                                                                    title={t.tech.fullName} style={{ maxWidth: 200 }}>
                                                                                    {t.tech.fullName}
                                                                                </div>
                                                                                {/* <span className="text-muted fw-semibold d-block fs-7">Zuid Area</span> */}
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="text-gray-800 fw-bold d-block mb-1 fs-6">
                                                                            {t.totalJobs}
                                                                        </span>
                                                                        <span className="fw-semibold text-gray-500 d-block fs-8">Unsettled Jobs</span>
                                                                    </td>
                                                                    <td>
                                                                        <div className={`fw-bold fs-6 ${(t.balance > 0 ? "text-success" : t.balance < 0 ? "text-danger" : "text-gray-800")}`}>
                                                                            {(t.balance > 0 ? "+" : "")}
                                                                            {moneyFormatter.format(Math.abs(t.balance) < 0.00001 ? 0 : t.balance)}
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-end pe-2">
                                                                        <a href="#" className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px"
                                                                            onClick={e => {
                                                                                e.preventDefault()
                                                                                selectedTechSet(t)
                                                                            }}>
                                                                            <i className="ki-outline ki-black-right fs-2 text-gray-500"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="tab_sources_balance">
                                            <div className="table-responsive scroll-y" style={{
                                                height: boxHeight
                                            }}>
                                                <table className="table table-hover table-row-dashed align-middle gs-0 gy-4 my-0">
                                                    <tbody>
                                                        {
                                                            model?.sources?.filter(f => {
                                                                if (searchKeyword == "") return true;
                                                                return f.name?.toLowerCase().includes(searchKeyword.toLowerCase())
                                                            }).map(t =>
                                                                <tr>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <Icon icon="bullhorn" size={22} />
                                                                            <div className="d-flex justify-content-start flex-column">
                                                                                <div className="text-gray-900 fw-bold text-hover-primaryfs-6 limited-text"
                                                                                    title={t.name} style={{ maxWidth: 200 }}>
                                                                                    {t.name}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="text-gray-800 fw-bold d-block mb-1 fs-6">
                                                                            {t.totalJobs}
                                                                        </span>
                                                                        <span className="fw-semibold text-gray-500 d-block fs-8">Unsettled Jobs</span>
                                                                    </td>
                                                                    <td>
                                                                        <div className={`fw-bold fs-6 ${(t.balance > 0 ? "text-success" : t.balance < 0 ? "text-danger" : "text-gray-800")}`}>
                                                                            {(t.balance > 0 ? "+" : "")}
                                                                            {moneyFormatter.format(Math.abs(t.balance) < 0.00001 ? 0 : t.balance)}
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-end pe-2">
                                                                        <a href="#" className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px"
                                                                            onClick={e => {
                                                                                e.preventDefault()
                                                                                selectedSourceSet(t)
                                                                            }}>
                                                                            <i className="ki-outline ki-black-right fs-2 text-gray-500"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>

                        <div className="col-12 col-lg-6">

                            <div className="card">
                                <div className="card-body py-0">

                                    <FlexRow className="mt-6 mb-5">
                                        <FlexRow className="nav-icon">
                                            <Icon icon="receipt" size={22} className="me-2" />
                                            <span className="nav-text text-gray-800 fw-bold fs-5 lh-1">
                                                Latest Transactions
                                            </span>
                                        </FlexRow>

                                        <div className="ms-auto">
                                            <Link to="/reports/balancetransactions" className="btn btn-sm btn-light-primary btn-active-light-primary">
                                                View All
                                                <Icon icon="chevron-right" className="ms-2" />
                                            </Link>
                                        </div>

                                    </FlexRow>

                                    <div>
                                        <div className="table-responsive scroll-y" style={{
                                            height: boxHeight
                                        }}>
                                            <table className="table table-hover table-row-dashed align-middle gs-0 gy-4 my-0">
                                                <tbody>

                                                    {
                                                        model?.transactions?.map(tr =>
                                                            <tr key={`tr-row-${tr.id}`}>
                                                                <td>

                                                                    <div className={`fw-bold fs-4 mb-2 ${tr.type == BalanceTransactionTypes.Pay ? "text-danger" : "text-success"}`}>
                                                                        {tr.type == BalanceTransactionTypes.Pay ? "-" : "+"}
                                                                        {moneyFormatter.format(tr.amount ?? 0)}
                                                                    </div>

                                                                </td>
                                                                <td>
                                                                    <FlexRow className="mb-1">
                                                                        {
                                                                            tr.party == BalanceTransactionParties.Source ?
                                                                                <>
                                                                                    <Icon icon="bullhorn" className="me-1" />
                                                                                    <span>
                                                                                        {tr.source?.name}
                                                                                    </span>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <Icon icon="user-helmet-safety" className="me-1" />
                                                                                    <span>
                                                                                        {tr.tech?.fullName}
                                                                                    </span>
                                                                                </>
                                                                        }
                                                                    </FlexRow>
                                                                    <div className="fs-8 limited-text"
                                                                        title={tr.description} style={{ maxWidth: 200 }}>
                                                                        {tr.description}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className={`mb-1`}>
                                                                        {toPrettyDate(tr.transactionDate)}
                                                                    </div>
                                                                    <div className="fs-8">
                                                                        <Icon icon="user" size={10} /> {tr.creatorUser?.fullName}
                                                                    </div>
                                                                </td>

                                                                <td className="text-end pe-2">
                                                                    <a href="#" className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px"
                                                                        onClick={e => {
                                                                            e.preventDefault()
                                                                            selectedTransactionSet(tr)
                                                                            editTransactionSet(true)
                                                                        }}>
                                                                        <i className="ki-outline ki-black-right fs-2 text-gray-500"></i>
                                                                    </a>
                                                                </td>

                                                            </tr>
                                                        )
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </Div>

                {
                    createTransaction &&
                    <TransactionForm key="tras-form-create"
                        defaultParty={SelectedParty}
                        onClose={() => createTransactionSet(false)} />
                }

                {
                    editTransaction && selectedTransaction &&
                    <TransactionForm key="tras-form-edit"
                        onClose={() => {
                            editTransactionSet(false)
                            selectedTransactionSet(undefined)
                        }}
                        item={selectedTransaction} />
                }

                {
                    selectedTech &&
                    <BalanceItemViewDrawer tech={selectedTech}
                        onClose={() => selectedTechSet(undefined)} />
                }

                {
                    selectedSource &&
                    <BalanceItemViewDrawer source={selectedSource}
                        onClose={() => selectedSourceSet(undefined)} />
                }

        </div>
    )
}